<template>
  <div>
    <ctnList :search_bar="true" />
  </div>
</template>
<script>
import ctnList from "@/components/portal/global/ContainerList.vue";

export default {
  name: "Container",
  components: {
    ctnList,
  },
};
</script>
